import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";

const token = localStorage.getItem('authToken');

class EditKuldevi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null,
      userName: "",
      title: "",
      category: '',
      categoryId: null,
      categoryChanged: false,
      areaInput: "",
      categoryData: [],
      currentImageUrl: null,
      submissionStatus: null,
      submeet: false,
      errors: [],
      city: "",
      showModal: false,
      selectedCategoryId: null,
      showModalReject: false,
      selectedCategoryIdReject: null,
      maxSize: 5 * 1024 * 1024,
      isLoading: true,
      id: null,
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.userData(id);
    } else {
      console.error("No match params found.");
    }
    this.fetchData();
  }

  userData = async (id) => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/kuldevi/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log(response.data);
        this.setState({
          title: response.data.title,
          category: response.data.category.name,
          categoryId: response.data.category.id,
          areaInput: response.data.description,
          city: response.data.city,
          state: response.data.state,
          currentImageUrl: `https://uma-classees.blr1.digitaloceanspaces.com/${response.data.image}`,
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/kuldevicategory`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        this.setState({ categoryData: response?.data?.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const file = e.target.files[0];
    const errors = [];

    if (file) {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file),
        });
      }
    }

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ submeet: true });

    const { textInput, title, areaInput, category, city, state, id } = this.state;

    try {
      const formData = new FormData();
      if (textInput) {
        formData.append('image', textInput);
      }
      formData.append('title', title);
      formData.append('description', areaInput);
      formData.append('category', category);
      formData.append('state', state);
      formData.append('city', city);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/kuldevi/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push("/kuldevidevatalist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, showModal, selectedCategoryId, state, selectedCategoryIdReject, showModalReject, title, currentImageUrl, city, category, categoryData, submeet, areaInput, submissionStatus, isLoading } = this.state;

    const isTitleValid = title?.trim()?.length > 0;
    const isCityValid = city?.trim()?.length > 0;
    const isStateValid = state?.trim()?.length > 0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Kuldevi / Devata</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label htmlFor="bloodGroup">Category</label>
                <select
                  className={`form-control ${submeet && !this.state.categoryId && "parsley-error"}`}
                  value={this.state.categoryId || ''}
                  name="category"
                  required=""
                  onChange={this.handleCategoryChange}
                >
                  <option value="" disabled>Select a category</option>
                  {categoryData && categoryData.map((key) => (
                    <option key={key.id} value={key.id}>{key.name}</option>
                  ))}
                </select>
                {submeet && !this.state.categoryId ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Category is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Image</label>
                {currentImageUrl && (
                  <div className="image-preview">
                    <img
                      src={currentImageUrl}
                      alt="Current"
                      style={{ width: '200px', height: 'auto' }}
                    />
                  </div>
                )}
                <input
                  type="file"
                  onChange={this.handleChange}
                />
                {this.state.errors.length > 0 && (
                  <div className="error-messages">
                    {this.state.errors.map((error, index) => (
                      <div key={index} className="error-message">{error}</div>
                    ))}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>City</label>
                <input
                  className={`form-control ${!isCityValid && submeet && "parsley-error"}`}
                  value={city}
                  name="city"
                  required=""
                  type="text"
                  onChange={(e) => this.setState({ city: e.target.value })}
                />
                {!isCityValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>State</label>
                <input
                  className={`form-control ${!isStateValid && submeet && "parsley-error"}`}
                  value={state}
                  name="state"
                  required=""
                  type="text"
                  onChange={(e) => this.setState({ state: e.target.value })}
                />
                {!isStateValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"}`}
                  value={areaInput}
                  name="description"
                  required=""
                  onChange={(e) => this.setState({ areaInput: e.target.value })}
                />
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={submeet && !(isTitleValid && isCityValid && isStateValid && category)}
              >
                Save Changes
              </button>

              {submissionStatus === 'success' && (
                <div className="alert alert-success">
                  Category updated successfully!
                </div>
              )}

              {submissionStatus === 'error' && (
                <div className="alert alert-danger">
                  An error occurred. Please try again.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  notifyGeneralInfo,
};

export default withRouter(connect(null, mapDispatchToProps)(EditKuldevi));
